import { PureComponent, Fragment } from 'react';
import { func, arrayOf, shape, string } from 'prop-types';
import { connect } from 'react-redux';

import { messagesApi } from './messages.api';
import { messagesActions } from './messages-actions/page-messages.actions';
import { bannerComponents } from './banners';

export const withMessageBanner = (pageId, shouldUseShopAvailability) => (Component) =>
  class ComponentWithMessageBanner extends PureComponent {
    static propTypes = {
      messages: arrayOf(
        shape({
          type: string.isRequired,
          message: shape({
            title: string.isRequired,
            text: string,
            href: string,
            linkLabel: string,
          }).isRequired,
        }),
      ).isRequired,
      shopId: string,

      dispatchPushPageMessages: func.isRequired,
    };

    static defaultProps = {
      shopId: undefined,
    };

    componentDidMount() {
      const { dispatchPushPageMessages, shopId } = this.props;

      messagesApi
        .getPageMessages(pageId, shouldUseShopAvailability ? shopId : undefined)
        .then((messages) => dispatchPushPageMessages(messages));
    }

    render() {
      const { messages, ...rest } = this.props;

      return (
        <Fragment>
          {messages.map(({ type, message }) => {
            const BannerComponent = bannerComponents[type];
            return BannerComponent && <BannerComponent key={type} message={message} />;
          })}
          <Component {...rest} />
        </Fragment>
      );
    }
  };

export const mapStateToProps = ({
  messages: { page: messages },
  appointment: {
    draft: {
      shop: { id: shopId },
    },
  },
}) => ({
  messages,
  shopId,
});

const mapDispatchToProps = {
  dispatchPushPageMessages: messagesActions.pushPageMessages,
};

export const ConnectedWithMessageBanner = (pageId, shouldUseShopAvailability) => (Component) =>
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withMessageBanner(pageId, shouldUseShopAvailability)(Component));
